import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const services = [{
  title: "Strategic Planning",
  summary: "Comprehensive roadmaps designed to align your corporate vision with actionable milestones for sustainable growth.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554409/img/strategic_planning.png",
  link: "/GrowthSolutionsPage"
}, {
  title: "Market Analysis",
  summary: "Deep-dive analytics and competitive intelligence to identify untapped opportunities in shifting global markets.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554409/img/market_analysis.png",
  link: "/TheStrategistPage"
}, {
  title: "Corporate Restructuring",
  summary: "Optimizing organizational hierarchy and operational workflows to maximize efficiency and reduce overhead.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554409/img/corporate_restructuring.png",
  link: "/GetStartedPage"
}, {
  title: "Digital Transformation",
  summary: "Integrating cutting-edge technologies to modernize legacy systems and enhance digital customer experiences.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554409/img/digital_transformation.png",
  link: "/GrowthSolutionsPage"
}];
export default function DetailedServiceCards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="detailed-service-cards" ref={ref} className={`dark bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {}
          <div className="lg:col-span-8 flex flex-col gap-6">
            {services.map((service, i) => <div key={i} data-index={i}>
                <Card className="group relative overflow-hidden border border-accent rounded-[2px] bg-transparent hover:bg-accent/5 transition-colors duration-300">
                  <div className="flex flex-col sm:flex-row h-full">
                    {}
                    <div className="relative w-full sm:w-32 md:w-48 shrink-0 h-48 sm:h-auto overflow-hidden">
                      <img src={service.image} alt={service.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                      {}
                      <div className="absolute inset-0 bg-green-900/20 mix-blend-multiply pointer-events-none" />
                    </div>

                    {}
                    <CardContent className="flex flex-col justify-center p-6 sm:p-8 grow">
                      <h2 className="font-serif text-3xl text-primary mb-3 tracking-wide">
                        {service.title}
                      </h2>
                      <p className="font-sans font-light text-lg text-muted-foreground mb-6 leading-relaxed">
                        {service.summary}
                      </p>
                      
                      <div className="mt-auto">
                        <Link to={service.link} className="inline-flex items-center gap-2 text-sm font-medium uppercase tracking-wider text-foreground group/link">
                          Learn More
                          <span className="relative h-[1px] w-8 bg-green-500 transition-all duration-300 group-hover/link:w-16" />
                          <ArrowRight className="w-4 h-4 text-green-500 -ml-1 transition-transform duration-300 group-hover/link:translate-x-1" />
                        </Link>
                      </div>
                    </CardContent>
                  </div>
                </Card>
              </div>)}
          </div>

          {}
          <div className="hidden lg:block lg:col-span-4" aria-hidden="true">
            {}
          </div>
        </div>
      </div>
    </section>;
}